/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon64Regular = forwardRef('ArrowDUturnUpRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M36 3.382a1.5 1.5 0 0 0-2 2.236l15.668 14.019c.126.112.237.234.334.363H28.5C17.73 20 9 28.73 9 39.5S17.73 59 28.5 59h15a1.5 1.5 0 0 0 0-3h-15C19.387 56 12 48.613 12 39.5S19.387 23 28.5 23h21.502c-.097.13-.208.25-.334.363L34 37.383a1.5 1.5 0 1 0 2 2.235l15.669-14.02a5.5 5.5 0 0 0 0-8.197L36 3.382Z" })));
});
